import React from "react";
import { motion } from "framer-motion";
import { Gift, ShieldCheck, Wallet, Lock, Users, Sparkles } from "lucide-react";
import { ADVANTAGES } from "../data/content";
import { fadeUp, staggerContainer, viewportOnce, EYEBROW } from "../lib/motion";

const ICONS = { Gift, ShieldCheck, Wallet, Lock, Users, Sparkles };

export const WhyChoose = () => {
  return (
    <section data-testid="why-section" className="relative bg-navy py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 noise opacity-[0.06]" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="max-w-3xl"
        >
          <span className={EYEBROW}>Keunggulan Kami</span>
          <h2 className="mt-5 font-serif text-4xl md:text-5xl tracking-tight text-white leading-[1.05]">
            Kenapa memilih <span className="italic text-gold">FYLegal.id?</span>
          </h2>
        </motion.div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6"
        >
          {ADVANTAGES.map((a, i) => {
            const Icon = ICONS[a.icon];
            return (
              <motion.div
                key={a.title}
                variants={fadeUp}
                data-testid={`advantage-${i}`}
                className="group rounded-3xl p-8 border border-white/10 bg-navy-light/60 hover:border-gold/40 hover:-translate-y-2 transition-all duration-400"
              >
                <div className="inline-flex items-center justify-center h-14 w-14 rounded-2xl mb-6 bg-gold/15 text-gold group-hover:bg-gold group-hover:text-navy transition-colors duration-300">
                  <Icon className="h-7 w-7" strokeWidth={1.75} />
                </div>
                <h3 className="font-serif text-2xl text-white leading-snug">{a.title}</h3>
                <p className="mt-3 leading-relaxed text-white/60 text-sm">{a.body}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
